/* eslint-disable no-undef */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useState } from 'react';
import { toast } from "react-toastify";
import { useWallet } from '@solana/wallet-adapter-react';
import { Program } from '@project-serum/anchor';
import { programId, tokenId, getProvider, getConnection } from '../config/web3';
import { Redirect, useParams } from 'react-router-dom';
import idl from '../idl.json';
import Spinner from '../components/spinner';
import { useEffect } from 'react';
import { PublicKey } from '@solana/web3.js';
import { Link } from 'react-router-dom';
import ClipLoader from 'react-spinners/ClipLoader'


function isMobile() {
  try {
    document.createEvent('TouchEvent')
    return true
  } catch (e) {
    return false
  }
}

function PollOption({ id, label, votes, total, voted, vote, setSelected, selected }) {
  let voteWidth = isMobile() ? 200 : 450;
  return (
    <button
      onClick={() => !voted && setSelected(id)}
      className="backdrop-brightness-80 items-center flex relative w-[200px] lg:w-[450px] h-20 text-lg p-4 rounded-xl outline-none border border-[white] hover:bg-[#7c88c266]"
      style={{ cursor: voted ? 'default' : 'pointer', background: selected === id ? '#7c88c266' : '' }}
    >
      {
         (
          <div
            className="h-full absolute rounded-[13px] top-0 left-0 bg-[#cc17f2]"
            style={{
              width: `${(votes / total * voteWidth) - 4}px`
            }}
          />
        )
      }
      <span className="relative font-semibold max-w-[70%] truncate text-[white]">{label}</span>
      {
        (
          <span className="absolute top-[50%] right-5 -translate-y-1/2 font-medium text-[white]">
            {votes} votes <br />
            {(votes / total * 100).toLocaleString()}%
          </span>
        )
      }
    </button>
  );
}

function Strawsoll() {
  const [poll, setPoll] = useState(null);
  const [voted, setVoted] = useState(false);
  const [title, setTitle] = useState();
  const [voting, setVoting] = useState(false);
  const [selected, setSelected] = useState(false)
  const { strawsollId } = useParams();
  const wallet = useWallet();

  const subscribe = useCallback(async () => {
    const provider = await getProvider(wallet)

    const program = new Program(idl, programId, provider);

    const pollPubKey = new PublicKey(strawsollId)

    const emitter = program.account.poll.subscribe(pollPubKey);
    emitter.on('change', (data) => setPoll(data.options.filter(option => !!option)));
    const state = await program.account.poll.fetch(pollPubKey);
    setTitle(state.title)
    setVoted(state.voters.find(voter => voter.toString() === provider.wallet.publicKey.toString()));
    setPoll(state.options.filter(option => !!option));
  }, [poll, strawsollId, wallet]);

  useEffect(() => {
    if (strawsollId && wallet.connected) {
      subscribe();
    }
  }, [strawsollId, wallet]);


  // Replace with the token mint address
  const [tokenBalance, setTokenBalance] = useState(0);
  useEffect(() => {
    const fetchTokenBalance = async () => {
      if (!wallet.publicKey) {
        console.log('Wallet not connected');
        return;
      }
      try {
        const connection = await getConnection()
        const tokenAccounts = await connection.getParsedTokenAccountsByOwner(
          wallet.publicKey,
          { mint: tokenId }
        );

        let balance = 0;
        tokenAccounts.value.forEach(accountInfo => {
          balance += accountInfo.account.data.parsed.info.tokenAmount.uiAmount;
        });

        setTokenBalance(balance);
      } catch (error) {
        console.error('Error fetching token balance:', error);
      }
    };
    if (wallet.publicKey)
      fetchTokenBalance();
  }, [wallet.publicKey]);

  // if (Number(tokenBalance) < 1) {
  //   return (
  //     <div className="flex flex-col items-center gap-20 justify-center w-full mt-20 relative">
  //       <h1 className="text-2xl md:text-4xl text-white font-bold">
  //         You need 100,000 DAO tokens on your wallet
  //       </h1>
  //       <Link to={`/`} className="bg-[#cc17f2] px-4 py-2 rounded-lg text-white font-semibold text-lg">Back</Link>
  //     </div>
  //   )
  // }

  async function vote(id) {
    console.log(id)
    const provider = await getProvider(wallet);
    const program = new Program(idl, programId, provider);
    const pollPubKey = new PublicKey(strawsollId)
    try {
      toast.loading(`Voting ...`);
      if (Number(tokenBalance) < 1) {
        toast.dismiss();
        toast.error('You Must Hold $DAO To Vote');
        return true;
      }
      setVoting(true);
      await program.methods
        .vote(id)
        .accounts({
          poll: pollPubKey,
          voter: provider.wallet.publicKey,
        })
        .rpc();

      setVoted(true);
      setVoting(false);
      toast.success(`Successfully Votted`);
      toast.dismiss();
    } catch (error) {
      toast.dismiss();
      toast.error("User rejected transaction");
      setVoting(false);
    }
  }

  if (!wallet.connected && !wallet.connecting) {
    return (
      <Redirect to="/" />
    );
  }

  return (
    <div className="flex flex-col items-center justify-center gap-4 w-full relative">
      <div className="mb-10 flex flex-col gap-3">
        <h1 className="text-4xl text-white font-bold text-center mt-10">Your time to vote!</h1>.
        <h1 className="text-2xl lg:text-3xl text-white font-bold text-center">Community Token Buy - 5th February 2025</h1>
        {
          voted && (
            <p className="text-lg text-center text-slate-100 font-bold">
              Only one vote allowed per wallet.
            </p>
          )
        }
        {
          (Number(tokenBalance) < 1)
          &&
          <div className="flex flex-col items-center gap-20 justify-center w-full mt-5 relative">
            <h1 className="text-1xl md:text-2xl text-white font-bold">
              ( You Must Hold $DAO To Vote )
            </h1>
          </div>
        }
      </div>
      {
        poll && (
          <>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              {
                poll.slice(0, 2).map(option =>
                  <PollOption key={option.id} {...option} total={poll.reduce((prev, curr) => prev + curr.votes, 0)} voted={voted} vote={vote} setSelected={setSelected} selected={selected} />)
              }
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              {
                poll.slice(2, 4).map(option =>
                  <PollOption key={option.id} {...option} total={poll.reduce((prev, curr) => prev + curr.votes, 0)} voted={voted} vote={vote} setSelected={setSelected} selected={selected} />)
              }
            </div>
          </>
        )
      }
      {
        !poll && <Spinner />
      }
      {!voting ?
        <div className='flex'>
          {selected > 0 && !voted ?
            <button
              onClick={() => !voted && vote(selected)}
              className="bg-[#cc17f2] px-4 py-2 rounded-lg text-white w-[200px] text-center font-semibold text-lg lg:mt-20 sm:mt-3 ml-3"
            >Vote
            </button> :
            <></>}
          <Link to={`/`} className="bg-[#cc17f2] px-4 py-2 rounded-lg text-white w-[200px] text-center font-semibold text-lg lg:mt-20 sm:mt-3 ml-3">Back</Link>
        </div>
        :
        <div className="lg:mt-20 sm:mt-3">
          <ClipLoader
            color={'white'}
            loading={voting}
            size={30}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        </div>
      }
    </div>
  );
}

export default Strawsoll;
